import { Backdrop, Card, Fade, Grid, Icon, Modal } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "70%", md: "50%", lg: "40%", xl: "30%"},
  p: 3,
};

export default function ModalConfirm({
  open,
  handleClose,
  title,
  message,
  func,
  pedirMotivo,
  icon,
  placeholder,
  cancelFunc,
  cancelLabel,
  confirmLabel,
  disableBackdropClose,
  wide,
}) {
  const [motivo, setMotivo] = useState("");
  const handleConfirm = () => {
    handleClose();
    func(motivo);
  };
  const handleCancel = () => {
    handleClose();
    cancelFunc(motivo);
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={(_, reason) => {
        if (disableBackdropClose && (reason === "backdropClick" || reason === "escapeKeyDown")) {
          return;
        }
        handleClose();
      }}
      disableEscapeKeyDown={disableBackdropClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Card
          sx={wide ? {
            ...style,
            width: { xs: "calc(100% - 24px)", sm: "86%", md: "760px" },
            maxWidth: "calc(100% - 24px)",
            maxHeight: "90vh",
            overflowY: "auto",
          } : style}
        >
          <SoftBox display="flex" gap={1}>
            {icon ? (<Icon fontSize="medium">{icon}</Icon>): null}
            <SoftTypography variant="h6">{title}</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Grid container justifyContent="start" alignItems="center" pb={1} pt={2}>
              {typeof message === "string" ? (
                <SoftTypography variant="h6" fontWeight="light">
                  {message}
                </SoftTypography>
              ) : message}
            </Grid>
          </SoftBox>
          {pedirMotivo && (
            <SoftBox>
              <SoftInput multiline rows={4} placeholder={placeholder} onChange={(e) => setMotivo(e.target.value)}/>
            </SoftBox>
          )}
          <SoftBox display="flex" justifyContent="flex-end" alignItems="center" pt={3} gap={2} flexDirection={{xs: "column", md: "row"}}>
            <SoftButton variant="gradient" color="primary" onClick={handleCancel} circular fullWidth>
              <Icon>undo</Icon>&nbsp;
              {cancelLabel}
            </SoftButton>
            <SoftButton variant="gradient" color="uproGreen" onClick={handleConfirm} circular disabled={pedirMotivo && !motivo?.trim()} fullWidth>
              <Icon>check</Icon>&nbsp;
              {confirmLabel}
            </SoftButton>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalConfirm.defaultProps = {
  func: () => {},
  title: "Confirmar",
  message: "¿Esta seguro que quiere confirmar?",
  pedirMotivo: false,
  icon: "check_circle",
  placeholder: "Ingrese un motivo",
  cancelFunc: () => {},
  cancelLabel: "Volver",
  confirmLabel: "Confirmar",
  disableBackdropClose: false,
  wide: false,
};

ModalConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.node,
  func: PropTypes.func,
  pedirMotivo: PropTypes.bool,
  icon: PropTypes.string,
  placeholder: PropTypes.string,
  cancelFunc: PropTypes.func,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  disableBackdropClose: PropTypes.bool,
  wide: PropTypes.bool,
};
